<div class="row solid-section">
    <div class="col-12 px-0">
      <div [id]="id" class="event__text-block quill-description">
        <div class="title" [innerHTML]="block.blockTitle"></div>
        <div class="text" [innerHTML]="block.text"></div>
      </div>
    </div>
</div>
